import React, { ElementType, FunctionComponent } from "react";
import { makeStyles, Typography, Icon, Box } from "@material-ui/core";
import Theme from "../.themes/common/Theme";

const useStyles = makeStyles<Theme, USPBlockProps>((theme: Theme) => ({
  linkWithIcon: {
    display: "flex",
    alignItems: "center",
  },
  icon: {
    width: "40px",
    height: "40px",
    marginRight: 16,
  },
  root: props => ({
    display: "flex",
    flexDirection: "column",
    marginRight: 24,
    marginLeft: 24,
    textAlign: props.iconUrl ? "left" : "center",
    [theme.breakpoints.down("sm")]: {
      marginBottom: 32,
    },
  }),
  headerWrapper: props => ({
    display: "flex",
    justifyContent: props.iconUrl ? "flex-start" : "center",
    marginBottom: 11,
  }),
  textwrapper: {
    display: "flex",
    flexDirection: "column",
  },
  header: {
    display: "flex",
    alignSelf: "center",
    textDecoration: "none",
    color: theme.palette.text.primary,
    ...theme.uspBlock?.header,
  },
  text: {
    color: theme.palette.text.primary,
    ...theme.uspBlock?.text,
  },
}));
interface USPBlockProps {
  iconUrl: any;
  title: any;
  titleType: any;
  description: any;
}

export const USPBlock: FunctionComponent<USPBlockProps> = (props: USPBlockProps) => {
  const classes = useStyles(props);

  return (
    <Box className={classes.root}>
      <Box className={classes.headerWrapper}>
        {props.iconUrl && (
          <Icon className={classes.icon}>
            <img className={classes.icon} src={props.iconUrl} alt='' />
          </Icon>
        )}
        <Typography
          variant='h3'
          component={(props.titleType as ElementType) ?? "h3"}
          className={classes.header}
          dangerouslySetInnerHTML={{ __html: props.title }}
        ></Typography>
      </Box>
      <Box>
        <Typography
          className={classes.text}
          variant='body2'
          component='p'
          dangerouslySetInnerHTML={{ __html: props.description }}
        ></Typography>
      </Box>
    </Box>
  );
};

export default USPBlock;
